import { useStyle } from '@/classify';
import { useGallery } from '@/hooks/Gallery/useGallery';
import { useMemo } from 'react';
import GalleryAd from './ad';
import defaultClasses from './gallery.module.css';
import { GalleryItem } from './item';
import GalleryItemShimmer from './item.shimmer';

const Gallery = props => {
  const { items, ads, pageControl } = props;

  const itemsClone = items.concat([]);

  ads?.forEach(ad => {
    if (pageControl.currentPage === ad.page) {
      itemsClone.splice(ad.position - 1, 0, ad);
    }
  });

  const classes = useStyle(defaultClasses, props.classes);
  const talonProps = useGallery();
  const { storeConfig } = talonProps;

  const galleryItems = useMemo(
    () =>
      // eslint-disable-next-line implicit-arrow-linebreak
      itemsClone.map((item, index) => {
        if (item === null) {
          return <GalleryItemShimmer key={index} />;
        }

        if (item.__typename === 'Advertisement') {
          return (
            <GalleryAd
              key={item.id}
              item={item}
            />
          );
        }

        return (
          <GalleryItem
            key={item.id}
            item={item}
            storeConfig={storeConfig}
            imgPriority={index < 4}
          />
        );
      }),
    [itemsClone, storeConfig],
  );

  return (
    <div
      data-cy='Gallery-root'
      className={classes.root}
      aria-busy='false'
    >
      <div className={classes.items}>{galleryItems}</div>
    </div>
  );
};

export default Gallery;
